import { render, staticRenderFns } from "./LabourerAssignmentTable.vue?vue&type=template&id=788606be&scoped=true&"
import script from "./LabourerAssignmentTable.vue?vue&type=script&lang=js&"
export * from "./LabourerAssignmentTable.vue?vue&type=script&lang=js&"
import style0 from "./LabourerAssignmentTable.vue?vue&type=style&index=0&id=788606be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788606be",
  null
  
)

export default component.exports